import React from 'react'
import { useTranslation } from 'react-i18next'
import browser, { windowOpen } from '../services/browser'
import { SCREEN_VIEW_APP_LINK, GUIDE_START_DATE } from '../constants'
import { useHistory } from 'react-router-dom'
import { List, ListItemButton, ListItemText, ListSubheader, ListItemIcon, Typography } from '@mui/material'
import { GuideBubble } from '../components/GuideBubble'
import { MobileUI } from '../components/MobileUI'
import { Icon } from '../components/Icon'

type Props = { className?: string; onClick?: () => void }

export const AndroidSetup: React.FC<Props> = ({ className, onClick }) => {
  const { t } = useTranslation()
  const history = useHistory()

  const handleClick = () => {
    if (browser.isAndroid) windowOpen(SCREEN_VIEW_APP_LINK, 'store', true)
    else history.push('/add/android')
    onClick?.()
  }

  return (
    <MobileUI android>
      <List className={className} dense disablePadding>
        <ListSubheader disableGutters>{t('androidSetup.thisSystem', 'This system')}</ListSubheader>
        <GuideBubble
          enterDelay={400}
          guide="registerMenu"
          placement="bottom"
          startDate={GUIDE_START_DATE}
          added={GUIDE_START_DATE}
          instructions={
            <>
              <Typography variant="h3" gutterBottom>
                <b>{t('androidSetup.guideTitle', 'Select a device')}</b>
              </Typography>
              <Typography variant="body2" gutterBottom>
                {t(
                  'androidSetup.guideBody',
                  'You can set up your Android device, or follow the simple instructions to set up one of the commonly used platforms.'
                )}
              </Typography>
            </>
          }
        >
          <ListItemButton disableGutters onClick={handleClick}>
            <ListItemIcon>
              <Icon name="android" fixedWidth platformIcon size="xxl" />
            </ListItemIcon>
            <ListItemText
              primary={t('androidSetup.thisDevice', 'This device')}
              secondary={t('androidSetup.thisDeviceDescription', 'Control or access this device and local network')}
            />
          </ListItemButton>
        </GuideBubble>
      </List>
    </MobileUI>
  )
}
